import React, { useEffect, useState } from "react";
import LoadingSpinner from "../../LoadingSpinner";
import axios from "axios";
import { BACKEND_URL, BACKEND_CALL_TIMEOUT } from "../../utils/constants";
import getFirebaseAuthToken from "../../services/fireBaseAuthenticationService";
import useUserStore from "../../stores/userStore";
import { hasPermission } from "../../utils/permissions";

const SickEventsTable = () => {
    const [data, setData] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);

    const { userIdToFirstName, currentUser } = useUserStore();


    useEffect(() => {
        let isMounted = true;

        const fetchSickEvents = async () => {
            setIsLoading(true);
            try {
                const token = await getFirebaseAuthToken();
                const response = await axios.post(
                    `${BACKEND_URL}/sick_hours`,
                    {},
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                        },
                        timeout: BACKEND_CALL_TIMEOUT,
                    }
                );
                if (isMounted) {
                    setData(response.data);
                }
            } catch (err) {
                console.error("Error fetching sick events:", err);
                if (isMounted) {
                    setError("Failed to load sick events.");
                }
            } finally {
                if (isMounted) {
                    setIsLoading(false);
                }
            }
        };

        fetchSickEvents();

        return () => {
            isMounted = false;
        };
    }, []);

    const formatToCentralDate = (isoDateString) => {
        if (!isoDateString) return "N/A";
        const utcDate = new Date(isoDateString);
        const centralTimeDate = new Date(
            utcDate.toLocaleString("en-US", { timeZone: "America/Chicago" })
        );
        return centralTimeDate.toISOString().slice(0, 10);
    };

    if (isLoading) return <LoadingSpinner />;
    if (error) return <div className="text-red-600">{error}</div>;

    return (
        <div className="overflow-x-auto w-full">
            <h3 className="text-lg font-semibold mb-2">Logged Sick Days</h3>
            <table className="table-auto w-full text-sm border border-gray-300">
                <thead className="bg-gray-100 text-gray-700">
                <tr>
                    <th className="px-2 py-1 border-b">User</th>
                    <th className="px-2 py-1 border-b">Work Date</th>
                    <th className="px-2 py-1 border-b">Sick Hours</th>
                </tr>
                </thead>
                <tbody>
                {data
                    .filter((row) => {
                        if (hasPermission('view_team_status')) return true;
                        return row.user_id === currentUser.user_id;
                    })
                    .map((row, idx) => (
                        <tr key={idx} className="bg-white even:bg-gray-50">
                            <td className="px-2 py-1 border-b">
                                {userIdToFirstName[row.user_id] || row.user_id}
                            </td>
                            <td className="px-2 py-1 border-b">
                                {formatToCentralDate(row.work_date)}
                            </td>
                            <td className="px-2 py-1 border-b">
                                {parseFloat(row.sick_hours).toFixed(2)}
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default SickEventsTable;
